var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFullBody(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons=Full Body"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.79663 21.2033V15H5.07166V18.9282H8.99991V21.2033H2.79663ZM14.9999 21.2033V18.9282H18.9282V15H21.2032V21.2033H14.9999ZM2.79663 9V2.79672H8.99991V5.07175H5.07166V9H2.79663ZM18.9282 9V5.07175H14.9999V2.79672H21.2032V9H18.9282Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.7678 18.9283H13.232V14.4701H14.72V8.53588H9.27979V14.4701H10.7678V18.9283ZM11.9999 8.03588C12.4213 8.03588 12.7736 7.89421 13.057 7.61088C13.3403 7.32754 13.482 6.97518 13.482 6.5538C13.482 6.13243 13.3403 5.78008 13.057 5.49675C12.7736 5.21341 12.4213 5.07175 11.9999 5.07175C11.5785 5.07175 11.2261 5.21341 10.9428 5.49675C10.6595 5.78008 10.5178 6.13243 10.5178 6.5538C10.5178 6.97518 10.6595 7.32754 10.9428 7.61088C11.2261 7.89421 11.5785 8.03588 11.9999 8.03588Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFullBody);
export default __webpack_public_path__ + "static/media/icon-full-body.19ae3b85300012881fb3987da3c295b7.svg";
export { ForwardRef as ReactComponent };